$(document).ready(function () {
    var searchSelect = $('.search-select');
    var _lang = $('html').attr('lang');
    var loadingText = 'loading...';
    var select_city = 'Select City';
    var select_country = 'Select country';
    if (_lang == 'ar') {
        loadingText = 'جاري التحميل';
        select_city = 'اختر المدينة';
        select_country = 'اختر الدولة';
    }if(_lang == 'fr'){
        loadingText = 'Chargement en cours';
        select_city = 'اختر المدينة';
        select_country = 'اختر الدولة';
    }

    searchSelect.selectpicker()

    $('.search-select.service_id').on('change', function () {
        var $this = $(this).parents('form');
        var service_id = $this.find('select.service_id');
        var city_id = $this.find('select.city_id');
        var country_id = $this.find('select.country_id');
        if (service_id == 0) {
            country_id.prop('disabled', true).val($("#country_id option:first").val());
            country_id.find('option').first().attr('data-subtext', '');
            city_id.prop('disabled', true).selectpicker('refresh');
            country_id.selectpicker('refresh');
            return false;
        }
        $.ajax({
            url: `${location.origin}/${_lang}/ajax/available-countries-by-service/${service_id.val()}`,
            method: 'get',
            dataType: 'json',
            beforeSend: function () {
                country_id.find('option').first().attr('data-subtext', loadingText)
                country_id.selectpicker('refresh')
            },
            success: function (data) {
                data = data.data
                var options =
                    "<option value='0' selected>" + select_country + "</option>"
                if (data.length > 0) {
                    data.forEach(function (element) {
                        options +=
                            `<option value="${element.slug}">${element.name}</option>`
                    })
                    country_id.html(options)
                    country_id.prop('disabled', false)
                    country_id.find('option').first().attr(
                        'data-subtext',
                        '')
                    country_id.selectpicker('refresh')

                } else {
                    country_id.prop('disabled', true).val('0');
                    country_id.find('option').first().prop('selected',
                        true);
                    country_id.find('option').first().attr(
                        'data-subtext',
                        '');
                    country_id.selectpicker('refresh');
                }
            },
            error: function () {
                country_id.find('option').first().attr('data-subtext',
                    '');
                country_id.selectpicker('refresh');
            }
        })
    })

    $('.search-select.country_id').on('change', function (e) {
        var $this = $(this).parents('form');
        var service_id = $this.find('select.service_id');
        var city_id = $this.find('select.city_id');
        var country_id = $this.find('select.country_id');
        var submitBtn =  $this.find('button[type="submit"]');
        if ($(this).val() != '0') {
            city_id.prop('disabled', false)
            city_id.selectpicker('refresh')
        } else {
            city_id.prop('disabled', true)
            city_id.selectpicker('refresh')
        }
        $.ajax({
            url: `${location.origin}/${_lang}/ajax/cities-by-service-and-country/${service_id.val()}/${country_id.val()}`,
            method: 'get',
            dataType: 'json',
            beforeSend: function () {
                city_id.find('option').first().attr('data-subtext', loadingText)
                city_id.selectpicker('refresh')
                submitBtn.addClass('loading')
            },
            success: function (data) {
                submitBtn.removeAttr('disabled');
                submitBtn.removeClass('loading');
                data = data.data
                var options =
                    "<option value='0' selected> " + select_city + " </option>";
                if (data.length > 0) {
                    data.forEach(function (element) {
                        options +=
                            `<option value="${element.slug}">${element.title}</option>`
                    })
                    city_id.html(options)
                    city_id.prop('disabled', false)
                    city_id.find('option').first().attr('data-subtext',
                        '')
                    city_id.selectpicker('refresh')

                } else {
                    city_id.prop('disabled', true).val('0');
                    city_id.find('option').first().prop('selected',
                        true);
                    city_id.find('option').first().attr('data-subtext',
                        '');
                    city_id.selectpicker('refresh');
                }
            },
            error: function () {
                city_id.find('option').first().attr('data-subtext', '');
                city_id.selectpicker('refresh');
            }
        })
        
        submitBtn.on("click", function() {
            var service = service_id.val();
            var _url = service + '/';
            var country = country_id.val()
            if (country == 0) return false
            var city = city_id.val()
            _url += country != 0 ? country + '/' : ''
            _url += city != 0 ? city + '/' : (service == 'cars' ? 'all' : '')
            window.location.pathname = `${_lang}/${_url}`
        })
    });
});